import { Inject } from '@odinjs/odin';

import { FetchAPI, FieldAPI, FormAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch } from '@philips-emr/tws-core/lib/client';
import { FetchEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from '../BaseController';

interface Retorno {
  dsMotivoRejeicao: string;
  dsObservacaoRejeicao: string;
}
@Controller({ fragment: 'motivo-rejeicao' })
class MotivoRejeicaoController extends BaseController {

  @Inject('fetch-consulta')
  fetchConsulta: FetchAPI;
  @Inject('form-motivo')
  formMotivo: FormAPI;
  @Inject('field-motivo')
  fieldMotivo: FieldAPI;
  @Inject('field-observacao')
  fieldObservacao: FieldAPI;

  @OnAfterFetch({ target: 'fetch-consulta' })
  onAfterFetch(event: FetchEvent): void {
    if(!event.data) {
      return;
    }
    const data = event.data as Retorno;
    const { dsMotivoRejeicao, dsObservacaoRejeicao } = data;
    if (!dsMotivoRejeicao) {
      this.fieldMotivo.setData({ dsMotivoRejeicao: '-' });
    }
    if (!dsObservacaoRejeicao) {
      this.fieldObservacao.setData({ dsObservacaoRejeicao : '-' });
    }

  }

}

export default MotivoRejeicaoController;
